export const FETCH_USERLOGIN_REQUEST = "FETCH_USERLOGIN_REQUEST";
export const FETCH_USERLOGIN_SUCCESS = "FETCH_USERLOGIN_SUCCESS";
export const FETCH_USERLOGIN_FAILURE = "FETCH_USERLOGIN_FAILURE";

export const CREATE_USERLOGIN_REQUEST = "CREATE_USERLOGIN_REQUEST";
export const CREATE_USERLOGIN_SUCCESS = "CREATE_USERLOGIN_SUCCESS";
export const CREATE_USERLOGIN_FAILURE = "CREATE_USERLOGIN_FAILURE";

export const UPDATE_USERLOGIN_REQUEST = "UPDATE_USERLOGIN_REQUEST";
export const UPDATE_USERLOGIN_SUCCESS = "UPDATE_USERLOGIN_SUCCESS";
export const UPDATE_USERLOGIN_FAILURE = "UPDATE_USERLOGIN_FAILURE";

export const DELETE_USERLOGIN_REQUEST = "DELETE_USERLOGIN_REQUEST";
export const DELETE_USERLOGIN_SUCCESS = "DELETE_USERLOGIN_SUCCESS";
export const DELETE_USERLOGIN_FAILURE = "DELETE_USERLOGIN_FAILURE";